import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import SEO from "./SEO";

export default function PrivacyPolicy() {
  const { t } = useTranslation();

  return (
    <div className="app">
      <SEO 
        title={`${t("footer.privacy")} - TraveLina`}
        description="Politika privatnosti TraveLina putničke agencije."
        keywords="politika privatnosti, zaštita podataka, TraveLina"
      />
      <header className="navbar">
        <div className="container nav-inner">
          <div className="nav-left">
            <Link to="/" className="logo" style={{ textDecoration: "none", color: "inherit" }}>
              {t("brand")}
            </Link>
          </div>
          <nav className="nav-links">
            <Link to="/" style={{ textDecoration: "none", color: "#9ca3af" }}>
              {t("nav.home")}
            </Link>
          </nav>
        </div>
      </header>

      <main>
        <section className="section" style={{ paddingTop: "3rem" }}>
          <div className="container" style={{ maxWidth: "800px" }}>
            <h1 style={{ marginBottom: "1.5rem", fontSize: "2rem" }}>
              Politika privatnosti
            </h1>

            <div style={{ lineHeight: "1.8", color: "#cbd5f5" }}>
              <h2 style={{ marginTop: "2rem", marginBottom: "1rem", fontSize: "1.3rem" }}>
                1. Uvod
              </h2>
              <p style={{ marginBottom: "1rem" }}>
                TRAVELINA, OBRT ZA TRGOVINU I PRUŽANJE TURISTIČKIH USLUGA, VL. LINA SKENDER, CESARICA, PRIMORSKA 1 (u daljnjem tekstu: "mi", "nas", "naša agencija") 
                poštuje vašu privatnost i posvećen je zaštiti vaših osobnih podataka. Ova politika privatnosti 
                objašnjava kako prikupljamo, koristimo, čuvamo i štitimo vaše osobne podatke kada koristite 
                našu web stranicu i usluge.
              </p>

              <h2 style={{ marginTop: "2rem", marginBottom: "1rem", fontSize: "1.3rem" }}>
                2. Prikupljeni podaci
              </h2>
              <p style={{ marginBottom: "1rem" }}>
                Prikupljamo sljedeće vrste osobnih podataka:
              </p>
              <ul style={{ marginLeft: "2rem", marginBottom: "1rem" }}>
                <li>Ime i prezime</li>
                <li>Email adresa</li>
                <li>Broj telefona</li>
                <li>Informacije o putovanjima (destinacija, datum, broj osoba)</li>
                <li>Poruke i upiti koje nam šaljete</li>
              </ul>

              <h2 style={{ marginTop: "2rem", marginBottom: "1rem", fontSize: "1.3rem" }}>
                3. Kako koristimo vaše podatke
              </h2>
              <p style={{ marginBottom: "1rem" }}>
                Vaše osobne podatke koristimo za:
              </p>
              <ul style={{ marginLeft: "2rem", marginBottom: "1rem" }}>
                <li>Komunikaciju s vama u vezi s upitima i rezervacijama</li>
                <li>Pripremu i organizaciju putovanja</li>
                <li>Slanje informacija o našim uslugama</li>
                <li>Poboljšanje naših usluga i web stranice</li>
                <li>Ispunjenje zakonskih obveza</li>
              </ul>

              <h2 style={{ marginTop: "2rem", marginBottom: "1rem", fontSize: "1.3rem" }}>
                4. Zaštita podataka
              </h2>
              <p style={{ marginBottom: "1rem" }}>
                Primjenjujemo odgovarajuće tehničke i organizacijske mjere zaštite kako bismo zaštitili 
                vaše osobne podatke od neovlaštenog pristupa, gubitka ili uništenja.
              </p>

              <h2 style={{ marginTop: "2rem", marginBottom: "1rem", fontSize: "1.3rem" }}>
                5. Vaša prava
              </h2>
              <p style={{ marginBottom: "1rem" }}>
                Imate pravo:
              </p>
              <ul style={{ marginLeft: "2rem", marginBottom: "1rem" }}>
                <li>Pristupiti svojim osobnim podacima</li>
                <li>Ispraviti netočne podatke</li>
                <li>Zatražiti brisanje podataka</li>
                <li>Ograničiti obradu podataka</li>
                <li>Prenijeti podatke</li>
                <li>Prigovoriti obradi podataka</li>
              </ul>

              <h2 style={{ marginTop: "2rem", marginBottom: "1rem", fontSize: "1.3rem" }}>
                6. Kontakt
              </h2>
              <p style={{ marginBottom: "1rem" }}>
                Za sva pitanja u vezi s vašim osobnim podacima, kontaktirajte nas:
              </p>
              <p style={{ marginBottom: "2rem" }}>
                <strong>TRAVELINA, OBRT ZA TRGOVINU I PRUŽANJE TURISTIČKIH USLUGA, VL. LINA SKENDER, CESARICA, PRIMORSKA 1</strong>
                <br />
                Tel: +385 91 214 4477
                <br />
                Email: Info@linatravelina.eu
              </p>

              <div style={{ marginTop: "3rem", paddingTop: "2rem", borderTop: "1px solid rgba(148, 163, 184, 0.3)" }}>
                <Link 
                  to="/" 
                  className="btn primary"
                  style={{ textDecoration: "none", display: "inline-block" }}
                >
                  ← Povratak na početnu
                </Link>
              </div>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}




